import { Theme, css } from '@emotion/react';

export const tabRoot = ({ colors, font, typography, spacing }: Theme) => css`
  color: ${colors.textDark};
  font-family: ${font.medium};
  font-size: ${typography.pxToRem(14)};
  font-weight: 500;
  line-height: 1.4;
  opacity: 1;
  min-width: 30px;
  text-transform: none;
  padding: ${spacing(1)}px ${spacing(2)}px;
`;

export const tabSelected = ({ colors }: Theme) => css`
  color: ${colors.textPrimary};
`;

export const tabIconWrapper = () => css`
  flex-direction: row;
`;

export const tabLabelIcon = ({ spacing }: Theme) => css`
  min-height: 4.8rem;
  padding: ${spacing(1)}px ${spacing(2)}px;
  & .MuiTab-iconWrapper > svg {
    margin-bottom: 0;
    margin-right: ${spacing(1)}px;
    margin-left: -3px; /* accounts for padding in icon SVG so icon path is at the leftmost edge of the padding */
  }
`;
